import * as React from 'react';
import { GradebookTopBar } from './gradebookTopBar/GradebookTopBar';
import { PropTypes } from 'prop-types';
import gradebookPlaceholder from '../../../styles/common/images/gradebook_placeholder.svg';
import GradesList from './gradesList/GradesList';
import { CONTEXT_PATH } from '../../../config_module';
import { GRADEBOOK_SCOPE } from '../../../const';
import GradesTasks from './gradesTasks/GradesTasks';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';
import GradebookMobilePlaceholder from '../mobile/GradebookMobilePlaceholder';

export class GradebookContainer extends React.Component {
  static propTypes = {
    colors: PropTypes.any,
    grades: PropTypes.object,
    groups: PropTypes.array,
    books: PropTypes.array,
    units: PropTypes.array,
    lessons: PropTypes.array,
    tasks: PropTypes.array,
    routeParams: PropTypes.any,
    activities: PropTypes.array,
    selectedBook: PropTypes.object,
    selectedUnit: PropTypes.object,
    setSelectedBook: PropTypes.func,
    setSelectedUnit: PropTypes.func,
    selectedLesson: PropTypes.object,
    setSelectedLesson: PropTypes.func,
    sectionId: PropTypes.string,
    role: PropTypes.string
  };

  getTypes() {
    let { selectedBook, selectedUnit, selectedLesson } = this.props;
    let type = 'book';
    if (selectedBook) {
      type = 'unit';
    }
    if (selectedUnit) {
      type = 'lesson';
    }
    if (selectedLesson) {
      type = 'activity';
    }
    return type;
  }

  getItems() {
    let type = this.getTypes();
    let { units, lessons, activities } = this.props;
    if (type === 'activity') {
      return activities;
    }
    if (type === 'lesson') {
      return lessons;
    }
    if (type === 'unit') {
      return units;
    }
    return [];
  }

  renderPlaceHolder() {
    return (
      <div className="gradebook-wrapper">
        <div className="gradebook-timeline-item">
          <div className="gradebook-animated-background">
            <div>
              <img alt="gradebook-placeholder" src={`${CONTEXT_PATH}${gradebookPlaceholder}`} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  isTasksScope = () => this.props.gradebookScope === GRADEBOOK_SCOPE.TASKS;

  renderGradeBookContent() {
    let {
      colors,
      grades,
      selectedBook,
      selectedUnit,
      selectedLesson,
      groups,
      sectionId,
      routeParams,
      setSelectedBook,
      setSelectedLesson,
      setSelectedUnit,
      books,
      units,
      lessons,
      gradebookScope,
      role
    } = this.props;
    return (
      <div className="right-content">
        <GradebookTopBar
          colors={colors}
          grades={grades}
          groups={groups}
          gradebookScope={gradebookScope}
          selectedBook={selectedBook}
          selectedUnit={selectedUnit}
          selectedLesson={selectedLesson}
        />
        <GradesList
          className="list-content"
          colors={colors}
          grades={grades}
          groups={groups}
          sectionId={sectionId}
          routeParams={routeParams}
          selectedBook={selectedBook}
          selectedUnit={selectedUnit}
          selectedLesson={selectedLesson}
          setSelectedLesson={setSelectedLesson}
          setSelectedBook={setSelectedBook}
          setSelectedUnit={setSelectedUnit}
          gradeTypes={this.getTypes()}
          gradebookScope={gradebookScope}
          items={this.getItems()}
          books={books}
          units={units}
          role={role}
          lessons={lessons}
        />
      </div>
    );
  }

  renderGradeBookTasks() {
    return <GradesTasks classroomId={this.props.routeParams.idClassroom} tasks={this.props.tasks} />;
  }

  render() {
    let { grades } = this.props;

    if (this.isTasksScope()) {
      return this.renderGradeBookTasks();
    }

    if (grades) {
      return this.renderGradeBookContent();
    }
    return (
      <Media query={MOBILE_MEDIA_QUERY}>
        {isMobile => (isMobile ? <GradebookMobilePlaceholder /> : this.renderPlaceHolder())}
      </Media>
    );
  }
}

export default GradebookContainer;
